// extracted by mini-css-extract-plugin
module.exports = {"footer":"Conditions_footer__13hZR","apply":"Conditions_apply__3mSNq","info":"Conditions_info__35Dq6"};